export default {
    empty_rows: {
        text: 'emptyRows'
    },
    rows_exceeded: {
        text: 'rowsExceeded'
    },
    rows_sparse: {
        text: 'rowsSparse'
    },
    invalid_header: {
        text: 'headerFail'
    },
    invalid_columns: {
        text: 'invalidColumns'
    },
    empty_cell: {
        text: 'emptyCell'
    },
    invalid_dni: {
        text: 'invalidDni'
    },
    duplicate_dni: {
        text: 'duplicatedDni'
    },
    invalid_gender: {
        text: 'invalidGender'
    },
    invalid_support_card: {
        text: 'invalidSupportCard'
    },
    invalid_card_limit_value: {
        text: 'invalidCardLimitValue'
    },
    invalid_card_limit_amount: {
        text: 'invalidCardLimitAmount'
    },
    invalid_support_payment_link: {
        text: 'invalidSupportPaymentLink'
    },
    invalid_level: {
        text: 'invalidLevel'
    },
    invalid_dwell_time: {
        text: 'invalidDwellTime'
    },
    invalid_sector: {
        text: 'invalidSector'
    },
    invalid_management: {
        text: 'invalidManagement'
    },
    invalid_support_account: {
        text: 'invalidSupportAccount'
    }
};
